import request from '@/utils/request'

// 获取配额调整审批主表信息
export function quotaMaintenanceCreateHead(createHeadId) {
  return request({
    url: `/api/srm-slcm/suppQuotaMaintenance/selectTable1ById/${createHeadId}`,
    method: 'get'
  })
}
